/** @format */

import { citiesDefaultCoordinates } from '@/components/page/PageListing/citiesDefaultCoordinates';

export const resetMapToDefault = ({ cityName, mapRef, singleMarker, zoom, eventData }: ResetMapToDefaultParams) => {
  if (!cityName) return;
  const coordinates = citiesDefaultCoordinates[cityName];
  if (!coordinates) return;

  mapRef?.current?.flyTo(
    {
      center: { lat: coordinates.latitude, lng: coordinates.longitude },
      zoom: singleMarker ? 12 : zoom,
    },
    eventData,
  );
  return;
};

type ResetMapToDefaultParams = {
  cityName?: string;
  mapRef: React.RefObject<any>;
  singleMarker: boolean;
  zoom: number;
  eventData: MoveMapEventData;
};

export interface MoveMapEventData {
  autoCenterOnMarkersChanged?: boolean;
}
